/**
 * Task priority is stored as an int (1=Urgent … 4=Low). These map it to labels
 * and the design's priority color tokens so rows/menus don't redefine it inline.
 */
export const PRIORITY_LABEL: Record<number, string> = {
  1: "Urgent",
  2: "High",
  3: "Medium",
  4: "Low",
};

// CSS custom properties from because-ui.css (--prio-*).
export const PRIORITY_COLOR_VAR: Record<number, string> = {
  1: "var(--prio-urgent)",
  2: "var(--prio-high)",
  3: "var(--prio-medium)",
  4: "var(--prio-low)",
};

export const PRIORITY_OPTIONS: { value: number; label: string }[] = [
  { value: 1, label: "Urgent" },
  { value: 2, label: "High" },
  { value: 3, label: "Medium" },
  { value: 4, label: "Low" },
];

export function priorityLabel(p: number): string {
  return PRIORITY_LABEL[p] ?? "—";
}

export function priorityColorVar(p: number): string {
  return PRIORITY_COLOR_VAR[p] ?? "var(--muted)";
}
